// Auto-generated by scripts/generate-build-info.mjs. Do not edit.
export const buildInfo = {
    commit: 'ed0fd34',
    builtAt: '2026-08-10T08:14:52.624Z',
} as const;
